module.exports = __webpack_public_path__ + "img/bestseller-list.23c00d98.png";